// Bicycle Axios 인스턴스 설정
import axios, { AxiosInstance } from 'axios';
import { API_BASE_URL, API_TIMEOUT } from './config';

// Bicycle API 전용 Axios 인스턴스 생성
export const bicycleApiInstance: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request 인터셉터
bicycleApiInstance.interceptors.request.use(
  (config) => {
    // 개발 환경에서만 로그 출력
    if (process.env.NODE_ENV === 'development') {
      console.log('Bicycle API Request:', config.method?.toUpperCase(), config.url);
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Response 인터셉터
bicycleApiInstance.interceptors.response.use(
  (response) => {
    // 개발 환경에서만 로그 출력
    if (process.env.NODE_ENV === 'development') {
      console.log('Bicycle API Response:', response.status, response.config.url);
    }
    return response;
  },
  (error) => {
    console.error('Response error:', error.response?.status, error.config?.url);
    
    // 에러 처리
    if (error.response) {
      switch (error.response.status) {
        case 401:
          console.error('Unauthorized');
          break;
        case 404:
          console.error('Not Found');
          break;
        case 500:
          console.error('Server Error');
          break;
        default:
          console.error('API Error:', error.response.data);
      }
    }
    
    return Promise.reject(error);
  }
);
